module.exports = __webpack_public_path__ + "img/text-layout.ccff4126.svg";